<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { Helper, debounce } from '@/mixin/helper'
import { getToolsClient } from '@/services/tools'

const toolsAxios = getToolsClient()

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  data() {
    return {
      phaseOneShow: false,
      sortBy: 'license_plate',
      sortDesc: false,
      loading: false,
      vehicles: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 1,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      status: 'I',
      filteredItems: [],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      return 'Kendaraan'
    },

    vehicle() {
      return [
        {
          key: 'license_plate',
          label: this.$t('task.column.licensePlate'),
          sortable: true,
        },
        {
          key: 'imei',
          label: this.$t('task.column.imei'),
          sortable: true,
        },
        {
          key: 'company.companyName',
          label: this.$t('task.column.company'),
          sortable: true,
        },
        {
          key: 'vehicleType',
          label: this.$t('vehicle.status.vehicleType'),
          sortable: true,
        },
        {
          key: 'fleet_status',
          label: this.$t('vehicle.status.status'),
          sortable: true,
        },
        {
          key: 'vehicle_status.latitude',
          label: this.$t('vehicle.status.latitude'),
          sortable: true,
        },
        {
          key: 'vehicle_status.longitude',
          label: this.$t('vehicle.status.longitude'),
          sortable: true,
        },
        {
          key: 'vehicle_status.is_engine_on',
          label: this.$t('vehicle.status.ignition'),
          sortable: true,
        },
        {
          key: 'vehicle_status.speed',
          label: this.$t('vehicle.status.speed'),
          sortable: true,
        },
        {
          key: 'vehicle_status.battery',
          label: this.$t('vehicle.status.battery'),
          sortable: true,
        },
        {
          key: 'vehicle_status.motion_status',
          label: this.$t('vehicle.status.motionStatus'),
          sortable: true,
        },
        {
          key: 'vehicle_status.last_receive_at',
          label: this.$t('vehicle.status.lastReceive'),
          sortable: true,
        },
      ]
    },

    rows() {
      return this.vehicles.length
    },
  },
  created() {
    this.getVehicles()
  },
  methods: {
    async getVehicles() {
      this.loading = true
      const payload = {
        page: this.currentPage,
        size: this.perPage,
        q: this.filter,
        filters: 'company:companyName:notilike:McEasy Default',
        includes: 'company:inner:companyId',
        fields:
          'vehicle:licensePlate,imei,fleetStatus;company:companyName;vehicleType:manufacturer,model,type,category;vehicleStatus:latitude,longitude,engineOn,speed,battery,motionStatus,lastReceiveAt',
      }

      const vehicles = await toolsAxios
        .get('/vehicle', {
          headers: { 'Accept-Language': process.env.VUE_APP_I18N_LOCALE },
          params: payload,
        })
        .catch((error) => {
          this.handleError(error)
        })

      if (!vehicles.data?.data) {
        this.loading = false
        return
      }

      this.vehicles = vehicles.data.data
      this.filteredItems = vehicles.data.data
      this.totalRows = vehicles.data.total_count
      this.currentPage = vehicles.data.page
      this.perPage = vehicles.data.size
      this.totalPages = vehicles.data.total_pages

      this.loading = false
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    changePage(e) {
      this.currentPage = e
      this.getVehicles()
    },
    resetFilter(e) {
      this.currentPage = 1
      this.size = e
      this.getVehicles()
    },
    searchData: debounce(function () {
      this.getVehicles()
    }, 600),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <p class="mb-4">{{ $t('master.textVehicle') }}</p>

    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-dropdown right variant="primary" menu-class="dropdown-menu-end" v-if="phaseOneShow">
          <template v-slot:button-content>
            Unduh <i class="mdi mdi-chevron-down ps-2"></i>
          </template>
          <b-dropdown-item
            ><i class="bx bx-book-content pe-1"></i> Unduh Tabel Excel</b-dropdown-item
          >
          <b-dropdown-item><i class="bx bx-book-content pe-1"></i> Unduh Tabel PDF</b-dropdown-item>
        </b-dropdown>
        <b-button
          @click="$router.push({ name: 'Master Home Page' })"
          variant="outline-primary"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="clearfix">
          <div class="float-end">
            <label class="d-inline-flex align-items-center mc-table-view__search">
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filter"
                type="search"
                :placeholder="`${$t('global.search')}...`"
                class="ms-2"
                @input="searchData"
              ></b-form-input>
            </label>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :items="vehicles"
            :fields="vehicle"
            class="datatables"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :busy="loading"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(vehicleType)="data">
              {{ data.item.vehicle_type ? `${data.item.vehicle_type.manufacturer} - ${data.item.vehicle_type.model} ${data.item.vehicle_type.type} ${data.item.vehicle_type.category}` : "-" }}
            </template>
            <template #cell(vehicle_status.last_receive_at)="data">
              {{
                data.item.vehicle_status.last_receive_at
                  ? momentDMHms(data.item.vehicle_status.last_receive_at)
                  : '-'
              }}
            </template>
            <template #cell(vehicle_status.is_engine_on)="data">
              {{ data.item.vehicle_status ? '' : '-' }}
              <span
                class="mc-status mc-status--green"
                v-if="data.item.vehicle_status.is_engine_on === `${$t('global.on')}`"
              >
                {{ data.item.vehicle_status.is_engine_on }}
              </span>
              <span
                class="mc-status mc-status--red"
                v-else-if="data.item.vehicle_status.is_engine_on === `${$t('global.off')}`"
              >
                {{ data.item.vehicle_status.is_engine_on }}
              </span>
            </template>
            <template #cell(vehicle_status.motion_status)="data">
              {{ data.item.vehicle_status ? '' : '-' }}
              <span
                class="mc-status mc-status--green"
                v-if="
                  data.item.vehicle_status.motion_status ===
                  `${$t('vehicle.motionStatus.inMotion')}`
                "
              >
                {{ data.item.vehicle_status.motion_status }}
              </span>
              <span
                class="mc-status mc-status--grey"
                v-else-if="
                  data.item.vehicle_status.motion_status ===
                    `${$t('vehicle.motionStatus.offline')}` ||
                  data.item.vehicle_status.motion_status === `${$t('vehicle.motionStatus.unknown')}`
                "
              >
                {{ data.item.vehicle_status.motion_status }}
              </span>
              <span
                class="mc-status mc-status--red"
                v-else-if="
                  data.item.vehicle_status.motion_status === `${$t('vehicle.motionStatus.parked')}`
                "
              >
                {{ data.item.vehicle_status.motion_status }}
              </span>
              <span
                class="mc-status mc-status--blue"
                v-else-if="
                  data.item.vehicle_status.motion_status ===
                  `${$t('vehicle.motionStatus.assisted')}`
                "
              >
                {{ data.item.vehicle_status.motion_status }}
              </span>
              <span
                class="mc-status mc-status--yellow"
                v-else-if="
                  data.item.vehicle_status.motion_status === `${$t('vehicle.motionStatus.idle')}`
                "
              >
                {{ data.item.vehicle_status.motion_status }}
              </span>
            </template>
            <template #cell(fleet_status)="data">
              {{ data.item.fleet_status ? '' : '-' }}
              <span
                class="mc-status mc-status--green"
                v-if="
                  data.item.fleet_status ===
                  `${$t('vehicle.status.active')}`
                "
              >
                {{ data.item.fleet_status }}
              </span>
              <span
                class="mc-status mc-status--red"
                v-else-if="
                  data.item.fleet_status === `${$t('device.archive')}`
                "
              >
                {{ data.item.fleet_status }}
              </span>
              <span
                class="mc-status mc-status--yellow"
                v-else-if="
                  data.item.fleet_status === `${$t('vehicle.status.repair')}`
                "
              >
                {{ data.item.fleet_status }}
              </span>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                <span>Menampilkan</span>
                <span>
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  @change="resetFilter"
                />
                </span>
                <span>entri.&nbsp;&nbsp;</span> 
                <span>Menampilkan&nbsp;
                  <strong>
                    {{filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0}}
                  </strong>
                  &nbsp;sampai&nbsp;
                  <strong>
                    {{
                      currentPage != totalPages
                        ? currentPage * perPage
                        : (currentPage - 1) * perPage + filteredItems.length
                    }}
                  </strong>
                  &nbsp;dari&nbsp;
                  <strong>{{ totalRows }}</strong>
                  &nbsp;entri.
                </span>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  @change="changePage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
